import { render } from "./CreatePhysician.vue?vue&type=template&id=323a9b4c&ts=true"
import script from "./CreatePhysician.ts?vue&type=script&lang=ts&external"
export * from "./CreatePhysician.ts?vue&type=script&lang=ts&external"

import "./CreatePhysician.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__